
/**
 * Module dependencies.
 */

import {
  acceptLanguageHeader,
  handleRequestError,
  request
} from 'src/core/utils/requests';

import { getApiEndpoint } from 'src/core/utils/api-url-resolver';

/**
 * `Query` type.
 */

type Query = {
  locale: string
};

/**
 * Export `fetchInstitutionalDownloads`.
 */

export async function fetchInstitutionalDownloads({ locale }: Query) {
  const endpoint = getApiEndpoint('getInstitutionalDownloads');

  try {
    const { data } = await request.get(endpoint, {
      headers: acceptLanguageHeader(locale)
    });

    return data?.data;
  } catch (error) {
    handleRequestError(error);
  }
}
